import { useSettings } from 'components/Settings'
import PrinterContext from 'contexts/PrinterContext'
import lodash from 'lodash'
import React, { useContext, useMemo, useState } from 'react'

const PrinterContextProvider = (props) => {
  const { children } = props

  const { settings, updateSetting } = useSettings()

  const printers = useMemo(() => lodash.get(global, 'possiblePrinters', {}), [])

  const currentPrinter = useMemo(() =>
    String(lodash.get(settings, 'printer_id', 0)),
  )

  const changePrinter = (value) => {
    updateSetting('printer_id', value)
  }

  return (
    <PrinterContext.Provider
      value={{
        printers,
        currentPrinter:
          currentPrinter && currentPrinter !== '0' ? currentPrinter : undefined,
        changePrinter,
      }}
    >
      {children}
    </PrinterContext.Provider>
  )
}

export default PrinterContextProvider
